import { Card } from 'antd';
import React from 'react';

import CardFormInput from '../CardForms/CardFormInput';
import { redirectToLogin } from '../utils';

export const CardWithTitle: React.FC<{
  title: string;
  children: any;
}> = props => <Card title={props.title}>{props.children}</Card>;

export const EmailFormInput = props => (
  <CardFormInput
    {...props}
    name="email"
    size={'large'}
    placeholder="Email Address"
    errorName={'email address'}
  />
);

export const PasswordFormInput = props => (
  <CardFormInput
    {...props}
    name={'password'}
    size={'large'}
    maxLength={20}
    placeholder={(props.newPassword ? 'New ' : '') + 'Password'}
    hasFeedback={!!props.newPassword}
    type="password"
    validatePassword={!!props.newPassword}
    errorName={'password'}
  />
);

export const CodeFormInput = () => (
  <CardFormInput
    name="code"
    size={'large'}
    placeholder="Enter 6 Digit Code"
    maxLength={6}
    errorName={'your 6 digit code'}
  />
);

export const goto = (where: string, push, pathname, onStateChange) => () => {
  if (pathname !== '/login') {
    redirectToLogin(push);
  } else {
    onStateChange(where, {});
  }
};

export const error = (err, authState, onAuthEvent) => {
  triggerAuthEvent(
    {
      data: errorMessage(err),
      type: 'error',
    },
    authState,
    onAuthEvent
  );
};

const errorMessage = err => {
  if (typeof err === 'string') {
    return err;
  }
  return err.message ? err.message : JSON.stringify(err);
};

const triggerAuthEvent = (event, authState, onAuthEvent) => {
  if (onAuthEvent) {
    onAuthEvent(authState, event);
  }
};
